"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNode = exports.isFilePath = exports.isFile = exports.isDataURIScheme = exports.isBrowser = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var isBrowser = exports.isBrowser = function isBrowser() {
  return typeof XMLHttpRequest !== 'undefined';
};
var isNode = exports.isNode = function isNode() {
  return typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]';
};
var isFilePath = exports.isFilePath = function isFilePath(input) {
  return typeof input === 'string';
};
var isFile = exports.isFile = function isFile(input) {
  return (0, _typeof2["default"])(input) === 'object' && Object.prototype.toString.call(input) !== '[object Object]';
};
var isDataURIScheme = exports.isDataURIScheme = function isDataURIScheme(input) {
  return typeof input === 'string' && input.startsWith('data:');
};